<template>
  <div>
    <v-container
      v-if="loaded && loadedMax"
      style="padding-top: 0px"
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
    >
      <v-row>
        <v-col cols="12" style="padding:8px 8px 0px 8px">
          <v-row>
            <v-col cols="4" xs="12">
              <span v-if="!myOwn" @click="routeUser()" class="hover pointer">
                <Avatar
                  v-if="user.avatar != null"
                  class="timeline-avatar"
                  :src="`https://tradeinpool.com/upload/${user.avatar}.png`"
                  :size="40"
                ></Avatar>
                <Avatar v-else class="timeline-avatar" :username="user.username" :size="40"></Avatar>
              </span>

              <span v-if="!myOwn" class="subheadline mt-3 ml-12">{{user.username}}'s Trading Diary</span>
              <span v-else class="subheadline">Trading Diary</span>
            </v-col>
            <v-col cols="8" xs="12">
              <div class="float-right" style="border-bottom: 1px solid #28303D">
                <div
                  @click="fromPicker ? fromPicker=false  : fromPicker=true,toPicker=false"
                  class="float-left pointer"
                >
                  <span class="fromto-font">Diary from</span>
                  <span class="ml-4 date-font">{{dateFrom}}</span>
                  <v-btn icon class="ml-4">
                    <v-icon color="#808F9C">arrow_drop_down</v-icon>
                  </v-btn>
                </div>
                <div
                  @click="toPicker ? toPicker=false : toPicker=true,fromPicker=false"
                  class="float-left pointer"
                >
                  <span class="ml-4 fromto-font">to</span>
                  <span class="ml-4 date-font">{{dateTo}}</span>
                  <v-btn icon class="ml-4">
                    <v-icon color="#808F9C">arrow_drop_down</v-icon>
                  </v-btn>
                </div>
                <v-btn icon class="my-0">
                  <v-icon size="18" color="#808F9C">filter_list</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col xl="9" lg="9" md="9" sm="12" class="px-4 pt-2">
          <v-row class="pa-0">
            <v-col cols="12" style="padding-top:0">
              <div class align="center">
                <div class="my-card px-6 pb-1 pt-2 mb-2">
                  <span
                    class="stat-number"
                    :class="boxReturn > 0 ? 'successes': boxReturn < 0 ? 'loss' : 'text-lightgrey'"
                  >{{boxReturn | roundFull}}%</span>
                  <div class="stat-text">Total return</div>
                </div>
                <div class="my-card px-6 pb-1 pt-2 ml-4 mb-4">
                  <span
                    class="stat-number"
                    :class="boxToday > 0 ? 'successes': boxToday < 0 ? 'loss' : 'text-lightgrey'"
                  >$ {{boxToday | roundFull}}</span>
                  <div class="stat-text">Today P/L</div>
                </div>
                <div
                  class="my-card px-6 pb-1 pt-2 ml-4 mb-4"
                  :class="boxWeek > 0 ? 'successes': boxWeek < 0 ? 'loss' : 'text-lightgrey'"
                >
                  <span class="stat-number">$ {{boxWeek | roundFull }}</span>
                  <div class="stat-text">This Week P/L</div>
                </div>
                <div
                  class="my-card px-6 pb-1 pt-2 ml-4 mb-4"
                  :class="boxMonth > 0 ? 'successes': boxMonth < 0 ? 'loss' : 'text-lightgrey'"
                >
                  <span class="stat-number">$ {{boxMonth | roundFull}}</span>
                  <div class="stat-text">This Month P/L</div>
                </div>
                <div class="my-card px-6 pb-1 pt-2 ml-4 mb-4 text-lightgrey">
                  <span class="stat-number">{{boxRRR}}</span>
                  <div class="stat-text">Total RRR</div>
                </div>
              </div>
            </v-col>
          </v-row>
          <div v-if="!noData">
            <v-lazy
              v-model="isActive"
              :options="{threshold: .5}"
              min-height="200"
              transition="fade-transition"
            >
              <v-timeline
                v-if="loaded"
                :align-top="true"
                :dense="$vuetify.breakpoint.smAndDown"
                :reverse="true"
                class="custom"
              >
                <transition-group name="list">
                  <TimelineItem v-for="item in data" :key="item._id" :record="item" />
                </transition-group>
              </v-timeline>
            </v-lazy>
          </div>
          <div
            style="height: 300px;display: table;text-align:center"
            class="width-full text-center"
            v-else
          >
            <div class="text-info" style="display: table-cell; vertical-align: middle;">
              <p class="bold" style="font-size:20px;margin-bottom:0px">NO DIARY DATA</p>
              <p>How to make diary record?</p>
              <p>
                A) Initiate diary manualy. Go to
                <span
                  class="more"
                  @click="routeToDiary"
                >Trading Diary</span> at main pool page.
              </p>
              <p>
                B) Initiate automaticaly when you make trade or initiate
                <span
                  class="more"
                  @click="routeToPrepare"
                >Trade Preparation</span>
              </p>
            </div>
          </div>
        </v-col>

        <v-col xl="3" lg="3" md="3" sm="12" class="pl-4 pr-4 pt-2">
          <v-row>
            <v-col xl="12" lg="12" md="12" sm="6" xs="12" class="pt-0 pr-0 mb-2">
              <v-card class flat>
                <MiniGauge :data="stats.successRate" />
              </v-card>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="6" xs="12" class="pt-0 pr-0 mb-2">
              <v-card class flat>
                <MiniWeek :data="stats.weekDays" />
              </v-card>
            </v-col>
            <v-col xl="12" lg="12" md="12" sm="6" xs="12" class="pt-0 pr-0 mb-2">
              <v-card class flat>
                <MiniSeven :inverse="true" :data="stats.lastSeven" />
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-dialog v-model="fromPicker" max-width="290px">
        <v-date-picker
          v-if="fromPicker"
          class="calendar mr-4"
          v-model="dateFrom"
          is-inline
          is-expanded
        />
      </v-dialog>
      <v-dialog v-model="toPicker" max-width="290px">
        <v-date-picker
          v-if="toPicker"
          class="calendar mr-4"
          v-model="dateTo"
          is-inline
          is-expanded
        />
      </v-dialog>
    </v-container>
    <div class="width-full" style="text-align:center;margin-top: 120px" v-else>
      <v-progress-circular :size="100" :width="7" color="#4dbac0" indeterminate>
        <div class="text-center">
          <div>
            <img class="brand-img" width="50" src="https://tradeinpool.com/img/logo.svg" />
          </div>
          <div>loading...</div>
        </div>
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
var moment = require("moment-timezone");
import MiniSeven from "@/components/minicharts_v2/miniSeven.vue";
import MiniWeek from "@/components/minicharts_v2/miniWeek.vue";
import MiniGauge from "@/components/minicharts_v2/miniGauge.vue";
import TimelineItem from "./item.vue";
import axios from "axios";
import Avatar from "vue-avatar";
export default {
  name: "DiaryList",
  components: { TimelineItem, MiniSeven, MiniWeek, MiniGauge, Avatar },
  data() {
    return {
      noData: false,
      isActive: false,
      myOwn: false,
      loaded: false,
      loadedMax: false,
      fromPicker: false,
      toPicker: false,
      dateFrom: null,
      dateTo: null,
      data: [],
      //box data
      boxReturn: 0,
      boxToday: 0,
      boxWeek: 0,
      boxMonth: 0,
      boxRRR: 0,
      // user data
      user: null,
      //chart data
      chartRatio: 0,
      chartWeek: [0, 0, 0, 0, 0, 0, 0],
      // trades stats
      tradesArr: [],
      maxTrades: [],
      stats: {
        successRate: 0,
        weekDays: [0, 0, 0, 0, 0, 0, 0],
        lastSeven: [],
        equity: []
      }
    };
  },
  computed: {
    ...mapGetters(["timezone", "username", "settings"])
  },
  watch: {
    $route: "fetchData",

    dateFrom(newVal) {
      if (new Date(newVal) <= new Date(this.dateTo)) {
        this.getHistory();
      } else {
        this.dateFrom = this.dateTo;
      }
      this.fromPicker = false;

      this.$store.dispatch("updateUserPreset", {
        section: "diaryFrom",
        value: this.dateFrom
      });
    },
    dateTo(newVal) {
      if (new Date(newVal) >= new Date(this.dateFrom)) {
        this.getHistory();
      } else {
        this.dateTo = this.dateFrom;
      }
      this.toPicker = false;
      this.$store.dispatch("updateUserPreset", {
        section: "diaryTo",
        value: this.dateTo
      });
    }
  },
  filters: {
    roundFull: function(value) {
      if (!value) return "";
      //return Number(value).toFixed(2)
      return Math.round(Number(value));
    }
  },
  methods: {
    routeToDiary() {
      return this.$router.push({ path: "/pool/focusdiary" });
    },
    routeToPrepare() {
      return this.$router.push({ path: "/pool/focusprepare" });
    },
    routeUser() {
      this.$router.push({
        name: "user",
        params: { name: this.$route.params.name }
      });
    },
    goTodetail(detail) {
      this.$router.push({
        name: "Diary",
        params: { name: this.$route.params.name, date: detail }
      });
    },
    fetchData() {
      //this.$router.push({name:'Diary',params:{name: "Wem"}})
    },
    closePickers() {
      this.fromPicker = false;
      this.toPicker = false;
    },
    setData(data) {
     // if (data.length > 0) {
        this.noData = false;
        this.data = data;
        this.statsRecalc();
      //} else {
        //this.loaded = true;
       // this.noData = true;
        //this.loaded = true;
     // }
      // ad trades to one aray for stat
    },
    setMax(data) {
      if (data.length > 0) {
        const moToday = moment().startOf("day");
        const moWeekStart = moment().startOf("week");
        const moMonthStart = moment().startOf("month");
        //moToday = moToday.startOf("day")

        var today = new Date();
        today.setHours(0, 0, 0, 0);
        var profits = [];
        //var profitsNominal = 0;
        var losts = [];
        //var lostsNominal = 0;
        this.maxTrades = data;
        this.boxWeek = 0;
        this.boxToday = 0;
        this.boxRRR = 0;
        this.boxMonth = 0;
        this.maxTrades.forEach((trade, index) => {
          var tradeTime = moment(trade.createdAt);

          if (tradeTime.isAfter(moWeekStart)) {
            //if (moment(trade.createdAt) >= moWeekStart) {
            this.boxWeek += trade.ClosedProfitLoss;
          }
          if (tradeTime.isAfter(moMonthStart)) {
            this.boxMonth += trade.ClosedProfitLoss;
          }
          if (tradeTime.isAfter(moToday)) {
            this.boxToday += trade.ClosedProfitLoss;
          }

          if (trade.ClosedProfitLoss <= 0) {
            losts.push(trade.ClosedProfitLoss);
            //lostsNominal += trade.ClosedProfitLoss;
          } else {
            //profitsNominal += trade.ClosedProfitLoss;
            profits.push(trade.ClosedProfitLoss);
          }

          if (index == this.maxTrades.length - 1) {
            var avgProfit = profits.reduce((a, b) => a + b, 0) / profits.length;
            var avgLost = Math.abs(
              losts.reduce((a, b) => a + b, 0) / losts.length
            );
            this.boxRRR = (avgProfit / avgLost).toFixed(2);
            //this.boxRRR = avgProfit + avgLost

            this.boxReturn = (
              (profits.length / (profits.length + losts.length)) *
              100
            ).toFixed(2);
          }
        });
        this.loadedMax = true
      }
      
      // ad trades to one aray for stat
    },
    statsRecalc() {
      if (this.data.length > 0) {
        var profits = [];
        var losts = [];
        this.equity = [];
        this.stats.succesRate = 0;
        this.tradesArr = [];
        this.stats.weekDays = [0, 0, 0, 0, 0, 0, 0];
        this.stats.lastSeven = [];
        this.data.forEach((day, idx) => {
          var dailyPL = 0;

          day._trades.forEach((trade, index) => {
            if (trade.ClosedProfitLoss > 0) {
              profits.push(trade.ClosedProfitLoss);
            } else {
              losts.push(trade.ClosedProfitLoss);
            }
            dailyPL += trade.ClosedProfitLoss;
            this.stats.weekDays[new Date(day.date).getDay()] += 1;
            this.tradesArr.push(trade);

            if (
              index == day._trades.length - 1 &&
              this.stats.lastSeven.length <= 7
            )
              this.stats.lastSeven.push({ createdAt: day.date, pl: dailyPL });
          });
          if (idx == this.data.length - 1) {
            this.stats.successRate =
              (profits.length / (losts.length + profits.length)) * 100;
            //setTimeout(() => {
            //this.loaded = true;
            //}, 500);
          }
        });
      }else{
        this.noData = true
      }

      setTimeout(() => {
        this.loaded = true
        this.loadedMax = true
        },1000)
      
      
    },
    getHistory() {
      this.loaded = false
      axios
        .post("https://tradeinpool.com:3001/api/request/diary/", {
          method: "history",
          user: this.$route.params.name,
          from: new Date(this.dateFrom),
          to: new Date(this.dateTo)
        })
        .then(response => {
          this.setData(response.data);
        })
         .catch(() => {
            this.loaded = true
          });
    },
    getTrades() {
      this.loadedMax = false
      var monthStart = new Date();
      (monthStart = new Date(
        monthStart.getFullYear(),
        monthStart.getMonth(),
        1
      )),
        axios
          .post("https://tradeinpool.com:3001/api/request/trades/", {
            method: "stat",
            user: this.$route.params.name,
            from: moment().startOf("month"),
            to: moment()
          })
          .then(response => {
            this.setMax(response.data);
          })
          .catch(() => {
            this.loadedMax = true
          });
    },

    getUser() {
      axios
        .post("https://tradeinpool.com:3001/api/request/user/", {
          method: "basic",
          name: this.$route.params.name
        })
        .then(response => {
          this.user = response.data;
        });
    },
    hasOwnNestedProperty(object, propertyPath) {
      if (!propertyPath) return false;

      var properties = propertyPath.split(".");
      var obj = object;

      for (var i = 0; i < properties.length; i++) {
        var prop = properties[i];

        if (!obj || !obj.hasOwnProperty(prop)) {
          return false;
        } else {
          obj = obj[prop];
        }
      }

      return true;
    }
  },
  created() {
    if (this.$route.params.name == this.username) {
      this.myOwn = true;
    } else {
      this.myOwn = false;
      this.getUser();
    }

    this.getTrades();
    this.getHistory();
  },
  mounted() {
    //this.getUser();

    //if (this.hasOwnNestedProperty(this.settings, "presets.diaryTo"))
    //  this.dateTo = this.settings.presets.diaryTo;
   // else 
    this.dateTo = moment().format("YYYY-MM-DD");

    //if (this.hasOwnNestedProperty(this.settings, "presets.diaryFrom"))
   //   this.dateFrom = this.settings.presets.diaryFrom;
   // else
      this.dateFrom = moment()
        .subtract("days", 14)
        .format("YYYY-MM-DD");
    //this.dateFrom = "2020-03-10";
    //this.dateTo = new Date(); //.toISOString().slice(0, 10);
    //this.dateTo.setDate(this.dateTo.getDate() + 1);
    //this.dateTo.setDate(this.dateTo.getDate() + 1);
    //this.dateTo = this.dateTo.toISOString().slice(0, 10);
  },
  sockets: {
    CLOSE_TRADE: function(data) {
      if (data._creator.username == this.$route.params.name) {
        if (this.data.length > 0) {
          this.getTrades();
          this.data.forEach((diary, index) => {
            var tradeFlooredDate = new Date(data.OpenDateTime * 1000);
            tradeFlooredDate.setHours(0, 0, 0, 0);
            tradeFlooredDate = moment(tradeFlooredDate).utc();
            tradeFlooredDate = new Date(tradeFlooredDate).toISOString();
            var dayDate = new Date(this.data[index].date).toISOString();
            if (tradeFlooredDate == dayDate) {
              this.data[index]._trades.unshift(data);
              this.statsRecalc();
            }
          });
        } else {
          this.getHistory();
          this.getTrades();
        }
      }
    }
  }
};
</script>

<style scoped>
.date-picker {
  z-index: 50;
  position: absolute;
}
</style>